<template>
	<div class="ReFlatListForBron">
		<label class="col-form-label w-100" v-if="flat_arr.length>0">Список квартир</label>
		<div v-for="objFlat in flat_arr" :key="objFlat.app_id"  class="flatlist mb-3">
			<div class="flatlist-row  pb-1">
				<div class="flatlist-item mr-2"><span>app_id: </span><p>ID {{objFlat.app_id}}</p></div>
				<div class="flatlist-item mr-2"><span>gk_name: </span><p>ЖК "{{objFlat.gk_name}}",</p></div>
				<div class="flatlist-item mr-2"><span>b_corp: </span><p>{{objFlat.b_corp}},</p></div>
				<div class="flatlist-item mr-2"><span>app_section: </span><p>сек. {{objFlat.app_section}},</p></div>
				<div class="flatlist-item mr-2"><span>app_number: </span><p>кв. № {{objFlat.app_number}},</p></div>
				<div class="flatlist-item mr-2"><span>app_rooms: </span><p>{{objFlat.app_rooms}},</p></div>
				<div class="flatlist-item mr-2"><span>app_baseflatcost: </span><p>{{objFlat.app_baseflatcost}} ₽</p></div>
			</div>
			<div class="flatlist-item button">
				<el-tooltip content="Выбрать квартиру" placement="top">
					<el-button class="no-border my-0"><button class="ml-3 btn btn-icon btn-simple btn-success" @click="setBronFields(objFlat)">
						<i class="tim-icons icon-simple-add"></i>
					</button></el-button>
				</el-tooltip>
			</div>
		</div>
	</div>
</template>

<script>
import { /*Tooltip,*/ Button } from 'element-ui';

	export default {
		name: 'ReFlatListForBron',
		components: {
			// Tooltip,	
			[Button.name]: Button	
		},
		props: {
			service_id: [String, Number], //тут было String, со String будет ошибка в консоли
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
		},
		data () {
			return {
				flat_arr:[],
			}
		},
		computed: {

		},
		methods: {
			setBronFields(objFlat){
				this.$emit("applyBronFields", objFlat);
			}
		},
		mounted(){
			this.$GVO.ApiCall('GET_ALL_OBJ_ON_SERVICE',{obj:'presentations',flt:{'service_id':this.service_id}})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success){
						if(typeof objApi.flat_arr != 'undefined' && objApi.flat_arr.length>0){
							this.flat_arr = objApi.flat_arr;
						}
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
		}
	}
</script>
<style scoped>

.flatlist, .flatlist-row  {
	display: flex;
	align-items: flex-end;
	width: 100%;
}
.flatlist-row {flex-wrap: wrap; border-bottom: 1px solid #01B0E0;}
.flatlist-item span:first-child {
	display: none;	
}
.flatlist-item p {margin-bottom: 0;}

</style>
